import { Controller } from "@hotwired/stimulus"

export default class UsersController extends Controller {}
